import * as cx from 'classnames';
import * as React from 'react';
import { SyntheticEvent } from 'react';
import { Button } from '..';
import * as Styles from './MembershipPanel.scss';

interface IOwnProps {
  isActive: boolean;
  buttonLabel: string;
  toggleActive: (event: SyntheticEvent<HTMLButtonElement>) => void;
  isFetching: boolean;
}

const MembershipPanel: React.SFC<IOwnProps> = ({ isActive, toggleActive, buttonLabel, isFetching, children }) => {

  const classNames = cx({
    [Styles.panel]: true,
    [Styles.active]: isActive,
    [Styles.loading]: isActive && isFetching,
  });

  return (
    <div className={classNames}>
      <div className={Styles.content}>
        <div className={Styles.children}>{children}</div>
        {!isActive && (
          <div>
            <Button
              type="button"
              onClick={toggleActive}
              variant="outline"
              align="center"
              size="medium"
              width="long"
              label={buttonLabel}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MembershipPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/MembershipPanel/MembershipPanel.tsx